var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-information-card1-container"},[_c('transition',{attrs:{"name":"changeShow","appear":""},on:{"after-enter":_vm.onAfterEnter}},[_c('el-card',{staticClass:"box-card"},[_c('p',[_c('i',{staticClass:"el-icon-icon-brandnew"}),_vm._v(" 待更新日志模块上线 ")]),_c('div',[_vm._v("实时了解MIS开发的工作进程")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }